module.exports = __webpack_public_path__ + "img/guanyu_yj.0c562d12.png";